import { createAsyncThunk } from "@reduxjs/toolkit";
import { postData } from "../../../../apiservice/apis";
import { getServiceExpenseVoucherApi } from "../../../../apiservice/service";
import { createServiceExpensePayload } from "../../../../utils/serviceExpense";
import { getAccountBySeachApi } from "../../../../apiservice/setting";
import {pathSpliter, dateTimeFormat, currentDateTime, } from "../../../../lib/functions";

// Fetch service expense number
export const fetchServiceExpenseNumber = createAsyncThunk(
  "serviceExpense/fetchServiceExpenseNumber",
  async (val) => {
    const res = await getServiceExpenseVoucherApi({ entryDate: val });
    return res.data;
  }
);

// Fetch service expense accs
export const fetchServiceExpenseAccs = createAsyncThunk(
  "serviceExpense/fetchServiceExpenseAccs",
  async () => {
    const res = await getAccountBySeachApi({
      multiType: ["service_expense_account"],
    });
    return res.data;
  }
);

// Create or Update Service Expense
export const createServiceExpense = createAsyncThunk(
  "serviceExpense/createServiceExpense",
  async (_, { getState, rejectWithValue }) => {
    try {
      const state = getState().serviceExpense;
      const { authInfo } = getState().auth;
    
      const payload = createServiceExpensePayload(state, authInfo);

      let res;
      if (state.service_ex_id) {
        res = await postData(`/service/update-service-expense`, {
          ...payload,
          service_ex_id: state.service_ex_id,
        });
      } else {
        res = await postData(`/service/create-service-expense`, payload);
      }

      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);


export const fetchServiceExpenseRecord = createAsyncThunk(
  "serviceExpense/fetchRecord",
  async ({ location }, { rejectWithValue }) => {
    try {
      let url = `/service/get-service-expense-record-with-details`;
      let para = {

        service_ex_id:
          pathSpliter(location.pathname, 3) !== undefined
            ? pathSpliter(location.pathname, 3)
            : 0,
      };

      if (pathSpliter(location.pathname, 2) === "order-to-service-expense") {
        url = `/get-service-expense-order-record-with-details`;
        para = {
          service_ex_o_id:
            pathSpliter(location.pathname, 3) !== undefined
              ? pathSpliter(location.pathname, 3)
              : 0,
        };
      }

      const res = await postData(url, para);

      if (res === "Error: Request failed with status code 401") {
        sessionStorage.clear();
        window.location.reload();
        return rejectWithValue("Unauthorized");
      }

      return res.data[0]; // pass the master + details payload to reducer
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);
